import { render, staticRenderFns } from "./EditTransferForm.vue?vue&type=template&id=5761a344&"
import script from "./EditTransferForm.vue?vue&type=script&lang=js&"
export * from "./EditTransferForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports